import BootCheckbox from "components/common/custom/forms/BootCheckbox";
import BootDatePicker from "components/common/custom/forms/BootDatePicker";
import TextInput from "components/common/custom/forms/BootTextField/TextField";
import MultiSelect from "components/common/MultiSelect";
import WizardModal from "components/wizard/WizardModal";

import React, { useEffect, useState } from "react";
import { Col, Form, OverlayTrigger, Tooltip, Row } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import {
  GetAllClaimPreAuthAllList,
  GetAllPractitonerList,
  GetAllPreauthorizationType,
  GetAllProviderName,
} from "../config/preauthorizationApi";
import {
  GetAllDropDownData,
  GetInsuranceList,
} from "features/eliglibility/eliglibility-check/config/eligibilityCheckApi";
import PreauthorizationRequestPractitioner from "./PreauthorizationRequestPractitioner";
import { useSearchParams } from "react-router-dom";
import { ViewSettings } from "features/field-settings/config/FieldSettingsApi";
import { handleResetAll } from "../config/preauthorizationSlice";
import {
  handlePreauthFormData,
  handleResetCreateClaim,
} from "features/cliams/config/claimSlice";
import { handleResetPatientSearch } from "features/eliglibility/eliglibility-check/config/eligibilityCheckSlice";
const imageContext = require.context("assets/img/insurance", false, /\.png$/);
const PreauthorizationRequest = ({
  watch,
  setValue,
  control,
  touchedFields,
  errors,
  setError,
  clearErrors,
}) => {
  const dispatch = useDispatch();
  const {
    visitReasons,
    stepFormData,
    preauthorizationType,
    preauthorizationSubType,
    providerName,
    viewPreauthorizationInfo,
    practitionerList,
    preauthorizationEligibility,
    processPriority,
  } = useSelector((state) => state.preauthorization);
  const { settingData } = useSelector((state) => state.settings);

  const { singleEligibilityData } = useSelector(
    (state) => state.eligibilityCheckList
  );
  const { genderList } = useSelector((state) => state.eligibilityCheck);

  const { insuranceList } = useSelector((state) => state.eligibilityCheck);

  const preauthRequest = viewPreauthorizationInfo?.provider_request;
  const preauthResponse = viewPreauthorizationInfo?.payer_response;

  const [filteredSubTypes, setFilteredSubTypes] = useState([]);
  const [showPayerAlert, setShowPayerAlert] = useState(false);
  const [mergedSpecialities, setMergedSpecialities] = useState([]);
  const [showTypeAlert, setShowTypeAlert] = useState(false);
  const [menuStates, setMenuStates] = useState({
    type: false,
    subType: false,
    practitioner: false,
  });
  const [searchParams] = useSearchParams();
  const reuse = searchParams.get("reuse") === "true";
  const followUp = searchParams.get("followup") === "true";
  const eligibility = searchParams.get("eligibility") === "true";
  const edit = searchParams.get("edit") === "true";
  const watchPreauthType = watch("preauthorization_type");
  const referralType = watch("visit_reason")?.visitreas_code === "referral";
  const coverageEligibility = preauthorizationEligibility?.entry?.find(
    (item) => item?.resource?.resourceType === "CoverageEligibilityResponse"
  )?.resource;

  const eligibilityID = coverageEligibility?.request?.identifier?.value;

  const isNCHI =
    watch("payer")?.insurance_company_id === 41 || watch("payer")?.value === 41;

  const isPrescription = preauthRequest?.prescription;


  const prescription = watch("prescription");
  const payer = watch("payer");

  useEffect(() => {
    if (prescription && payer) {
      const preauthSub = preauthorizationSubType?.filter(
        (item) => item?.claimsub_types_id === 2
      );

      setValue(
        "preauthorization_type",
        preauthorizationType?.find((item) => item?.claim_types_id === 4)
      );

      if (preauthSub?.length) {
        setValue("preauthorization_sub_type", {
          claimsub_types_id: preauthSub[0].claimsub_types_id,
          claimsub_types_code: preauthSub[0].claimsub_types_code,
          claimsub_types_name: preauthSub[0].claimsub_types_name,
        });
      }
      clearErrors("preauthorization_type", null);
      clearErrors("preauthorization_sub_type", null);
    } else if (payer && isNCHI) {
      setValue(
        "preauthorization_type",
        preauthorizationType?.find((item) => item?.claim_types_id === 1)
      );
    } else if (stepFormData) {
      setValue("preauthorization_type", stepFormData?.preauthorization_type);
      setValue(
        "preauthorization_sub_type",
        stepFormData?.preauthorization_sub_type
      );
    }
  }, [
    prescription,
    payer,
    isNCHI,
    stepFormData,
    preauthorizationType,
    preauthorizationSubType,
    setValue,
  ]);

  useEffect(() => {
    if (visitReasons?.length === 0) {
      dispatch(GetAllClaimPreAuthAllList());
    }
    if (preauthorizationType?.length === 0) {
      dispatch(GetAllPreauthorizationType());
    }
    if (practitionerList?.length === 0) {
      dispatch(GetAllPractitonerList());
    }
    if (insuranceList?.length === 0) {
      dispatch(GetInsuranceList());
    }
    if (genderList?.length === 0) {
      dispatch(GetAllDropDownData());
    }
    if (providerName?.length === 0) {
      dispatch(GetAllProviderName());
    }
    if (!settingData || settingData.length === 0) {
      dispatch(ViewSettings());
    }
  }, []);

  useEffect(() => {
    if (watch("prescription")) return;

    const selectedType = watchPreauthType?.claim_types_name;

    if (!selectedType) {
      setFilteredSubTypes([]);
      setValue("preauthorization_sub_type", null);
      return;
    }

    let updatedSubTypes = [];

    if (selectedType === "Institutional") {
      updatedSubTypes = preauthorizationSubType.filter(
        (sub) => sub.claimsub_types_name === "InPatient"
      );
    } else if (selectedType === "Professional") {
      updatedSubTypes = preauthorizationSubType.filter((sub) =>
        ["OutPatient", "Emergency"].includes(sub.claimsub_types_name)
      );
      // setValue("preauthorization_sub_type", null);
    } else {
      updatedSubTypes = preauthorizationSubType.filter(
        (sub) => sub.claimsub_types_name === "OutPatient"
      );
    }

    setFilteredSubTypes(updatedSubTypes);

    // ✨ If only one match → auto-select it
    if (updatedSubTypes.length === 1) {
      setValue("preauthorization_sub_type", {
        claimsub_types_id: updatedSubTypes[0].claimsub_types_id,
        claimsub_types_code: updatedSubTypes[0].claimsub_types_code,
        claimsub_types_name: updatedSubTypes[0].claimsub_types_name,
      });
    }
    // ✨ If Professional + 2 options + settingData exists → select from settings
    else if (
      selectedType === "Professional" &&
      updatedSubTypes.length === 2 &&
      settingData?.[0]?.fieldsetting_txt?.claimsub_types_name
    ) {
      const settingSubTypeId =
        settingData[0].fieldsetting_txt.claimsub_types_name;

      const matchFromSettings = updatedSubTypes.find(
        (sub) => sub.claimsub_types_id === settingSubTypeId
      );

      if (matchFromSettings) {
        setValue("preauthorization_sub_type", {
          claimsub_types_id: updatedSubTypes[0].claimsub_types_id,
          claimsub_types_code: updatedSubTypes[0].claimsub_types_code,
          claimsub_types_name: updatedSubTypes[0].claimsub_types_name,
        });
      } else {
        setValue("preauthorization_sub_type", null);
      }
    }
  }, [
    watchPreauthType,
    setValue,
    preauthorizationSubType,
    watch("prescription"),
    settingData,
    reuse,
    edit,
    followUp,
  ]);

  useEffect(() => {
    if (processPriority?.length > 0) {
      setValue(
        "priority_type",
        processPriority?.find((item) => item?.prcspri_code === "normal")
      );
    }
  }, [processPriority]);

  useEffect(() => {
    if (!reuse && !edit && !followUp && !stepFormData) {
      dispatch(handleResetAll({ check: "reset" }));
      dispatch(handleResetCreateClaim());
      dispatch(handlePreauthFormData({ check: "reset" }));
      dispatch(handleResetPatientSearch());
    }
  }, [reuse, followUp, edit]);

  const selectedPayer = watch("payer");

  const handleTypeMenuToggle = (isOpen) => {
    // 1) if opening & no payer → show modal & DO NOT open dropdown
    if (isOpen && !watch("payer")) {
      setShowPayerAlert(true);
      return setMenuStates((prev) => ({ ...prev, type: false }));
    }
    // 2) otherwise let it open/close
    setMenuStates((prev) => ({ ...prev, type: isOpen }));
  };

  const handleSubTypeMenuToggle = (isOpen) => {
    if (isOpen && !watch("preauthorization_type")) {
      setShowTypeAlert(true);
      return setMenuStates((prev) => ({ ...prev, subType: false }));
    }
    setMenuStates((prev) => ({ ...prev, subType: isOpen }));
  };
  const getPayerImage = () => {
    const nameSource = selectedPayer?.insurance_direct
      ? selectedPayer?.payer_name
      : `${selectedPayer?.payer_name} - ${selectedPayer?.insurance_shname}`;
    if (!nameSource) return null;

    const formattedName = nameSource
      .toLowerCase()
      .replace(/ /g, "_")
      .replace(/[^a-z0-9_]/g, "");

    try {
      const matches = imageContext
        .keys()
        .filter((path) => path.toLowerCase().includes(formattedName));

      return matches.length > 0 ? imageContext(matches[0]) : null;
    } catch (e) {
      console.error("Image load error:", e);
      return null;
    }
  };
  const payerImage = getPayerImage();

  console.log(
    {
      testsss: Boolean(
        preauthResponse?.offline_eligbid || preauthResponse?.offline_eligbdte
      ),
    },
    watch("offline")
  );

  useEffect(() => {
    if (preauthorizationEligibility?.id) {
      setValue(
        "online_eligibility_ref_no",
        watch("eliginility_ref_no") || eligibilityID
      );
    }
    if (eligibility && !reuse && !followUp && !edit) {
      const data = settingData?.[0];
      setValue(
        "online_eligibility_ref_no",
        watch("eliginility_ref_no") || singleEligibilityData?.eligibility_id
      );
      setValue(
        "payer",
        watch("payer") ||
        insuranceList?.find(
          (item) =>
            item?.insurance_company_id ===
            singleEligibilityData?.insurance_company_id
        )
      );
      setValue(
        "visit_reason",
        watch("visit_reason") ||
        visitReasons?.find(
          (item) => item?.visitreas_code === preauthRequest?.visitreasons
        )
      );
      setValue(
        "preauthorization_type",
        watch("preauthorization_type") ||
        preauthorizationType?.find(
          (item) =>
            item?.claim_types_id === data?.fieldsetting_txt?.claim_type
        )
      );
      setValue(
        "preauthorization_sub_type",
        watch("preauthorization_sub_type") ||
        preauthorizationSubType?.find(
          (item) =>
            item?.claimsub_types_id ===
            data?.fieldsetting_txt?.claimsub_types_name
        )
      );
      setValue(
        "priority_type",
        watch("priority_type") ||
        processPriority?.find(
          (item) =>
            item?.prcspri_code === data?.fieldsetting_txt?.process_prior
        ) ||
        processPriority?.filter((item) => item?.prcspri_code === "normal")[0]
      );
    } else if ((reuse || edit || followUp) && !eligibility) {
      setValue(
        "payer",
        watch("payer") ||
        insuranceList?.find(
          (item) =>
            item?.insurance_company_id ===
            viewPreauthorizationInfo?.insurance_company_id
        )
      );

      setValue(
        "preauthorization_type",
        watch("pereauthorization_type") ||
        preauthorizationType?.find(
          (item) =>
            item?.claim_types_code?.toLowerCase() ===
            preauthRequest?.claim_typenme?.toLowerCase()
        ) ||
        null
      );
      setValue(
        "prescription",
        touchedFields?.prescription ? watch("prescription") : isPrescription
      );
      setValue(
        "transferral",
        touchedFields?.transferral
          ? watch("transferral")
          : preauthRequest?.transfer
      );
      setValue(
        "offline",
        touchedFields?.offline
          ? watch("offline")
          : !!preauthResponse?.offline_eligbid
      );

      setValue(
        "preauthorization_sub_type",
        watch("preauthorization_sub_type") ||
        preauthorizationSubType?.find(
          (item) =>
            item?.claimsub_types_name?.toLowerCase() ===
            preauthRequest?.preauth_subtype?.toLowerCase()
        ) ||
        null
      );

      setValue(
        "priority_type",
        watch("priority_type") ||
        processPriority?.find(
          (item) => item?.prcspri_code === preauthRequest?.priority
        ) ||
        null
      );
      setValue(
        "prescription_ref_no",
        watch("prescription_ref_no") || preauthRequest?.prescripno || ""
      );
      setValue(
        "preauthorization_ref_no",
        watch("preauthorization_ref_no") || preauthResponse?.preauth_ref || ""
      );
      setValue(
        "online_eligibility_ref_no",
        watch("online_eligibility_ref_no") ||
        preauthResponse?.eligibility_reference ||
        ""
      );
      setValue(
        "offline_eligibility_date",
        watch("offline_eligibility_date") ||
        preauthResponse?.offline_eligbdte ||
        ""
      );
      setValue(
        "offline_eligibility_ref_no",
        watch("offline_eligibility_ref_no") ||
        preauthResponse?.offline_eligbid ||
        ""
      );

      setValue(
        "visit_reason",
        watch("visit_reason") ||
        visitReasons.find(
          (item) =>
            item?.visitreas_code?.toLowerCase() ===
            preauthRequest?.visitreasons
        )
      );
    } else if (stepFormData) {
      setValue("payer", stepFormData?.payer);
      setValue("visit_reason", stepFormData?.visit_reason);
      setValue("preauthorization_type", stepFormData?.preauthorization_type);
      setValue(
        "preauthorization_sub_type",
        stepFormData?.preauthorization_sub_type
      );
      setValue("priority_type", stepFormData?.priority_type);
      setValue("date", stepFormData?.date);
      setValue(
        "healthcare_practitioner",
        stepFormData?.healthcare_practitioner
      );
      setValue("practices", stepFormData?.practices);
      setValue("practitioner_roles", stepFormData?.practitioner_roles);
      setValue("prescription", stepFormData?.prescription);
      setValue("eliginility_ref_no", stepFormData?.eliginility_ref_no);
      setValue("offline_preauth_date", stepFormData?.offline_preauth_date);
      setValue("offline_preauth_id", stepFormData?.offline_preauth_id);
      setValue("offline", stepFormData?.offline);
      setValue("transferral", stepFormData?.transferral);
      setValue("identifier_type", stepFormData?.identifier_type);
      setValue("prescription_ref_no", stepFormData?.prescription_ref_no);
    } else if (settingData?.[0]?.server_url) {
      console.log("iiii589898");

      const data = settingData?.[0];
      setValue(
        "visit_reason",
        watch("visit_reason") ||
        visitReasons?.find(
          (item) =>
            item?.visitreas_code === data?.fieldsetting_txt?.sup_info_vreas
        )
      );
      setValue(
        "preauthorization_type",
        watch("preauthorization_type") ||
        preauthorizationType?.find(
          (item) =>
            item?.claim_types_id === data?.fieldsetting_txt?.claim_type
        )
      );
      setValue(
        "preauthorization_sub_type",
        watch("preauthorization_sub_type") ||
        preauthorizationSubType?.find(
          (item) =>
            item?.claimsub_types_id ===
            data?.fieldsetting_txt?.claimsub_types_name
        )
      );
      setValue(
        "priority_type",
        watch("priority_type") ||
        processPriority?.find(
          (item) =>
            item?.prcspri_code === data?.fieldsetting_txt?.process_prior
        ) ||
        processPriority?.filter((item) => item?.prcspri_code === "normal")[0]
      );
    }
  }, [
    stepFormData,
    eligibility,
    reuse,
    edit,
    followUp,
    searchParams,
    singleEligibilityData,
    viewPreauthorizationInfo,
    preauthRequest,
    insuranceList,
    visitReasons,
  ]);

  return (
    <Row>
      {!watch("payer") ? (
        <Col xs={12} sm={6} md={4}>
          <Form.Group controlId="payer">
            <label className="form-label">
              Payer <span className="text-danger">*</span>
            </label>
            <Controller
              name="payer"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <MultiSelect
                  {...field}
                  options={insuranceList?.map((payer) => ({
                    value: payer.insurance_company_id, // unique ID
                    payer_id: payer.payer_id,
                    payer_name: payer.payer_name,
                    insurance_direct: payer.insurance_direct,
                    insurance_shname: payer.insurance_shname,
                    label:
                      payer.insurance_direct === 1
                        ? payer.payer_name
                        : `${payer.payer_name} - ${payer.insurance_shname}`,
                  }))}
                  isClearable={true}
                  placeholder="Choose..."
                  onChange={(selected) => {
                    setValue(
                      "payer",
                      selected
                        ? {
                          payer_id: selected?.payer_id,
                          payer_name: selected?.payer_name,
                          insurance_company_id: selected?.value,
                          insurance_direct: selected?.insurance_direct,
                          insurance_shname: selected?.insurance_shname,
                        }
                        : null
                    );
                    clearErrors("payer");
                  }}
                  value={
                    field.value
                      ? {
                        value: field.value.insurance_company_id,
                        payer_id: field.value.payer_id,
                        insurance_direct: field.value.insurance_direct,
                        label:
                          field.value.insurance_direct === 1
                            ? field.value.payer_name
                            : `${field.value.payer_name} - ${field.value.insurance_shname}`,
                      }
                      : null
                  }
                />
              )}
            />
          </Form.Group>
        </Col>
      ) : (
        <Col xs={12} sm={6} md={4}>
          <Row className="align-items-center">
            <Col xs={6}>
              <Form.Group controlId="payer">
                <label className="form-label">
                  Payer <span className="text-danger">*</span>
                </label>
                <Controller
                  name="payer"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <MultiSelect
                      {...field}
                      options={insuranceList?.map((payer) => ({
                        value: payer.insurance_company_id, // unique ID
                        payer_id: payer.payer_id,
                        payer_name: payer.payer_name,
                        insurance_direct: payer.insurance_direct,
                        insurance_shname: payer.insurance_shname,
                        label:
                          payer.insurance_direct === 1
                            ? payer.payer_name
                            : `${payer.payer_name} - ${payer.insurance_shname}`,
                      }))}
                      isClearable={true}
                      placeholder="Choose..."
                      onChange={(selected) => {
                        setValue(
                          "payer",
                          selected
                            ? {
                              payer_id: selected?.payer_id,
                              payer_name: selected?.payer_name,
                              insurance_company_id: selected?.value,
                              insurance_direct: selected?.insurance_direct,
                              insurance_shname: selected?.insurance_shname,
                            }
                            : null
                        );
                        clearErrors("payer");
                      }}
                      value={
                        field.value
                          ? {
                            value: field.value.insurance_company_id,
                            payer_id: field.value.payer_id,
                            insurance_direct: field.value.insurance_direct,
                            label:
                              field.value.insurance_direct === 1
                                ? field.value.payer_name
                                : `${field.value.payer_name} - ${field.value.insurance_shname}`,
                          }
                          : null
                      }
                    />
                  )}
                />
              </Form.Group>
            </Col>

            <Col xs={6}>
              {payerImage && (
                <img
                  src={payerImage}
                  alt={selectedPayer?.payer_name}
                  style={{
                    width: "100%",
                    maxWidth: "80px",
                    objectFit: "contain",
                  }}
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              )}
            </Col>
          </Row>
        </Col>
      )}
      <Col xs={12} sm={6} md={4}>
        <Form.Group controlId="visit_reason">
          <label className="form-label">
            Visit Reason{!isNCHI && <span className="text-danger">*</span>}
          </label>
          <Controller
            name="visit_reason"
            control={control}
            isRequired={!isNCHI}
            rules={{ required: !isNCHI }}
            render={({ field }) => (
              <>
                <MultiSelect
                  {...field}
                  menuPlacement="auto"
                  closeMenuOnSelect={false}
                  isMulti={false}
                  size="sm"
                  isClearable={true}
                  options={visitReasons?.map((visit) => ({
                    value: visit.visitreas_code,
                    label: visit.visitreas_name,
                  }))}
                  placeholder="Choose..."
                  //   className={error ? "is-invalid" : ""}
                  value={
                    field.value
                      ? {
                        value: field.value.visitreas_code,
                        label: field.value.visitreas_name,
                      }
                      : null
                  }
                  onChange={(selected) => {
                    setValue(
                      "visit_reason",
                      selected
                        ? {
                          visitreas_name: selected?.label,
                          visitreas_code: selected?.value,
                        }
                        : null
                    );
                    clearErrors("visit_reason", null);
                  }}
                />
              </>
            )}
          />
        </Form.Group>
      </Col>
      <Col xs={12} sm={6} md={4}>
        <Row>
          <Col xs={9}>
            <Form.Group controlId="preauthorization_type">
              <label className="form-label">
                Preauthorization Type <span className="text-danger">*</span>
              </label>
              <Controller
                name="preauthorization_type"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <MultiSelect
                    {...field}
                    options={preauthorizationType?.map((item) => ({
                      value: item.claim_types_id,
                      label: item.claim_types_name,
                    }))}
                    placeholder="Choose..."
                    // menuIsOpen={menuStates.type}
                    isClearable={true}
                    onMenuOpen={() => handleTypeMenuToggle(true)}
                    onMenuClose={() => handleTypeMenuToggle(false)}
                    disabled={watch("prescription") || isNCHI}
                    onChange={(selected) => {
                      setValue(
                        "preauthorization_type",
                        selected
                          ? {
                            claim_types_name: selected.label,
                            claim_types_id: selected.value,
                          }
                          : null
                      );
                      clearErrors("preauthorization_type", null);
                      clearErrors("preauthorization_sub_type", null);
                    }}
                    value={
                      field.value
                        ? {
                          value: field.value.claim_types_id,
                          label: field.value.claim_types_name,
                        }
                        : null
                    }
                  />
                )}
              />
            </Form.Group>
          </Col>
          <Col xs={3}>
            <OverlayTrigger
              className="bg-warning"
              placement="bottom"
              flip
              overlay={
                <Tooltip className="bg-warning rounded text-warning">
                  Make a prescription request
                </Tooltip>
              }
            >
              <div>
                <BootCheckbox
                  name="prescription"
                  label="Prescription"
                  disabled={isNCHI}
                  control={control}
                  size="lg"
                />
              </div>
            </OverlayTrigger>
          </Col>
        </Row>
      </Col>
      {/* Preauthorization Sub Type Field */}
      <Col xs={12} sm={6} md={4}>
        <Form.Group controlId="preauthorization_sub_type">
          <label className="form-label">
            Preauthorization Sub Type <span className="text-danger">*</span>
          </label>
          <Controller
            name="preauthorization_sub_type"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                options={filteredSubTypes.map((item) => ({
                  value: item?.claimsub_types_id,
                  label: item?.claimsub_types_name,
                  code: item?.claimsub_types_code,
                }))}
                placeholder="Choose..."
                menuIsOpen={menuStates.subType}
                disabled={watch("prescription") || isNCHI}
                isClearable={true}
                onMenuOpen={() => handleSubTypeMenuToggle(true)}
                onMenuClose={() => handleSubTypeMenuToggle(false)}
                onChange={(selected) => {
                  setValue(
                    "preauthorization_sub_type",
                    selected
                      ? {
                        claimsub_types_name: selected.label,
                        claimsub_types_id: selected.value,
                        claimsub_types_code: selected.code,
                      }
                      : null
                  );
                  clearErrors("preauthorization_sub_type", null);
                }}
                value={
                  field.value
                    ? {
                      value: field.value.claimsub_types_id,
                      label: field.value.claimsub_types_name,
                      code: field.value.claimsub_types_code,
                    }
                    : null
                }
              />
            )}
          />
        </Form.Group>
      </Col>
      <Col xs={12} sm={6} md={4}>
        <Form.Group controlId="payer">
          <label className="form-label">
            Priority Type <span className="text-danger">*</span>
          </label>
          <Controller
            name="priority_type"
            control={control}
            isRequired={true}
            rules={{ required: true }}
            render={({ field }) => (
              <>
                <MultiSelect
                  {...field}
                  menuPlacement="auto"
                  closeMenuOnSelect={false}
                  isClearable={true}
                  isMulti={false}
                  size="sm"
                  options={processPriority?.map((item) => ({
                    value: item.prcspri_code,
                    label: item.prcspri_name,
                  }))}
                  placeholder="Choose..."
                  //   className={error ? "is-invalid" : ""}
                  value={
                    field.value
                      ? {
                        value: field.value.prcspri_code,
                        label: field.value.prcspri_name,
                      }
                      : null
                  }
                  onChange={(selected) => {
                    setValue(
                      "priority_type",
                      selected
                        ? {
                          prcspri_name: selected?.label,
                          prcspri_code: selected?.value,
                        }
                        : null
                    );
                  }}
                />
              </>
            )}
          />
        </Form.Group>
      </Col>
      <Col xs={12} sm={6} md={4}>
        <BootDatePicker
          name="date"
          label="Date"
          size="sm"
          control={control}
          isRequired={true}
          rules={{ required: "Visit Date is Required" }}
          placeholder="dd-mm-yyyy hh:mm"
          dateFormat="dd-MM-yyyy hh:mm A"
          timeIntervals={15}
          showTimeSelect
          selected={watch("date")}
        />
      </Col>

      {!referralType &&
        (watch("offline") ? (
          <>
            <Col xs={12} sm={6} md={4}>
              <TextInput
                name="offline_eligibility_ref_no"
                placeholder="Offline Eligibility Ref. No"
                label="Offline Eligibility Ref. No"
                size="sm"
                control={control}
                required={false}
                rules={{ required: false }}
              />
            </Col>
            <Col xs={12} sm={6} md={4}>
              <BootDatePicker
                name="offline_eligibility_date"
                label="Offline Eligibility Date"
                size="sm"
                control={control}
                rules={{ required: watch("offline_eligibility_ref_no") }}
                selected={watch("offline_eligibility_date")}
                onChange={(newValue) =>
                  setValue("offline_eligibility_date", newValue)
                }
                placeholder="dd/mm/yyyy"
                isRequired={watch("offline_eligibility_ref_no")}
              />
            </Col>
            <Col xs={12} sm={6} md={4}>
              <Row>
                <Col xs={12} md={6}>
                  <BootCheckbox
                    name="offline"
                    label="Offline"
                    control={control}
                    size="lg"
                  />
                </Col>
                <Col xs={12} md={6}>
                  <OverlayTrigger
                    className="bg-primary"
                    placement="bottom"
                    flip
                    overlay={
                      <Tooltip className="bg-primary rounded text-primary">
                        Request to transfer this patient to another provider
                      </Tooltip>
                    }
                  >
                    <div>
                      <BootCheckbox
                        name="transferral"
                        label="Transferral"
                        control={control}
                        size="lg"
                      />
                    </div>
                  </OverlayTrigger>
                </Col>
              </Row>
            </Col>
          </>
        ) : (
          <>
            <Col xs={12} sm={6} md={4}>
              <Row className="align-items-center">
                <Col xs={9}>
                  <TextInput
                    name="online_eligibility_ref_no"
                    label="Online Eligibility Ref No"
                    control={control}
                    disabled={eligibility}
                    size="sm"
                    placeholder="Online Eligibility Ref No"
                  />
                </Col>
                <Col xs={3}>
                  <BootCheckbox
                    name="offline"
                    label="Offline"
                    control={control}
                    size="lg"
                  />
                </Col>
              </Row>
            </Col>
            <Col xs={12} sm={6} md={1}>
              <OverlayTrigger
                className="bg-primary"
                placement="bottom"
                flip
                overlay={
                  <Tooltip className="bg-primary rounded text-primary">
                    Request to transfer this patient to another provider
                  </Tooltip>
                }
              >
                <div>
                  <BootCheckbox
                    name="transferral"
                    label="Transferral"
                    control={control}
                    size="lg"
                  />
                </div>
              </OverlayTrigger>
            </Col>
          </>
        ))}

      <PreauthorizationRequestPractitioner
        control={control}
        setValue={setValue}
        watch={watch}
        mergedSpecialities={mergedSpecialities}
        setError={setError}
        clearErrors={clearErrors}
      />

      {referralType && (
        <motion.div
          style={{ border: "2px solid #d9f8eb" }}
          className="rounded p-3 position-relative  mt-3"
          initial={{ opacity: 0, y: 50 }}
          animate={{
            opacity: 1,
            y: 0,
          }}
          exit={{ opacity: 0, y: 50 }}
          transition={{ duration: 0.5 }}
        >
          {/* Floating Badge Header */}
          <div className="position-absolute top-0 start-40 translate-middle-y px-2">
            <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success">
              <span className="fs-11">Referral Info</span>
            </span>
          </div>

          {/* Form Row */}
          <Row className="align-items-end">
            <Col xs={12} sm={6} md={3}>
              <TextInput
                name="preauthorization_ref_no"
                label="Preauthorization Ref No."
                control={control}
                size="sm"
                required={referralType}
                rules={{ required: referralType }}
                placeholder="Preauthorization Ref No"
              />
            </Col>

            <Col xs={12} sm={6} md={3}>
              <TextInput
                errors={errors}
                name="referral_provider_practitioner"
                label="Referral Provider/Practitioner"
                control={control}
                size="sm"
                placeholder="Referral Provider/Practitioner"
              />
            </Col>

            <Col xs={12} sm={6} md={3}>
              <label className="form-label">Provider Name</label>
              <Controller
                name="provider_name"
                control={control}
                render={({ field, ref }) => (
                  <MultiSelect
                    {...field}
                    ref={ref}
                    menuPlacement="auto"
                    closeMenuOnSelect={false}
                    isMulti={false}
                    value={
                      field?.value
                        ? {
                          value: field?.value?.nphprov_cchiid,
                          label: field?.value?.nphprov_name,
                        }
                        : null
                    }
                    isClearable={true}
                    formatOptionLabel={({ label, value }) => (
                      <div>{`(${value}) - ${label}`}</div>
                    )}
                    options={providerName?.map((item) => ({
                      value: item?.nphprov_cchiid,
                      label: item?.nphprov_name,
                    }))}
                    onChange={(selected) => {
                      setValue(
                        "provider_name",
                        selected
                          ? {
                            nphprov_cchiid: selected?.value,
                            nphprov_name: selected?.label,
                          }
                          : null
                      );
                    }}
                    placeholder="Choose ..."
                  />
                )}
              />
            </Col>
          </Row>

          {/* Modals */}
        </motion.div>
      )}
      <WizardModal
        modal={showPayerAlert}
        setModal={() => setShowPayerAlert(false)}
        title="Payer Not Selected"
        description="Please select the Payer first before choosing Preauthorization Type."
      />
      <WizardModal
        modal={showTypeAlert}
        setModal={() => setShowTypeAlert(false)}
        title="Type Not Selected"
        description="Please select Preauthorization Type first before choosing Sub Type."
      />
      {watch("preauthorization_type")?.claim_types_id === 3 && (
        <motion.div
          style={{ border: "2px solid #d9f8eb" }}
          className="rounded p-3 position-relative  mt-3"
          initial={{ opacity: 0, y: 50 }}
          animate={{
            opacity: 1,
            y: 0,
          }}
          exit={{ opacity: 0, y: 50 }}
          transition={{ duration: 0.5 }}
        >
          {/* Floating Badge Header */}
          <div className="position-absolute top-0 start-40 translate-middle-y px-2">
            <span className="badge shadow-sm d-flex align-items-center justify-content-center badge-subtle-success">
              <span className="fs-11">Prescription Details</span>
            </span>
          </div>

          {/* Form Row */}
          <Row className="align-items-end g-3 pt-3">
            <Col xs={12} sm={6} md={3}>
              <TextInput
                errors={errors}
                name="prescription_ref_no"
                label="Prescription Ref No."
                control={control}
                size="sm"
                required={false}
                placeholder="Prescription Ref No"
              />
            </Col>
          </Row>
        </motion.div>
      )}
    </Row>
  );
};

export default PreauthorizationRequest;
